import React from 'react'
import ChangeProxyInput from './ChangeProxyInput'

const TheBox = (props) => {
    let { record } = props
    let daysInAWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    let style = {
        label: { fontWeight: 'bold' },
        bigFont: { fontSize: 'small' }
    }
    let carfax = {}
    let start = ""
    let end = ""
    let profit = 0

    if (record.carfax) {
        carfax = JSON.parse(record.carfax)
    }
    if (record.start) {
        let startTime = new Date(record.start)
        let dayIndex = startTime.getDay()
        let hour = startTime.getHours().toString()
        let mins = startTime.getMinutes().toString()
        if (mins.length < 2)
            mins = 0 + mins

        start = `${daysInAWeek[dayIndex]} ${hour}:${mins}`
    }
    if (record.end) {
        let endTime = new Date(record.end)
        let dayIndex = endTime.getDay()
        let hour = endTime.getHours().toString()
        let mins = endTime.getMinutes().toString()
        if (mins.length < 2)
            mins = 0 + mins

        end = `${daysInAWeek[dayIndex]} ${hour}:${mins}`
    }


    if (record.cad && record.proxy) {
        profit = record.cad - record.proxy
    }




    return (
        <div style={{ display: 'flex', maxWidth: 'px' }}>
            <div style={{ flex: 15 }}><a target='_blank' href={record.auction_url || ""}><img style={{ width: '100%' }} src={record.pic || ""} alt={record.vin || ""} /></a></div>
            <div style={{ flex: 85, marginLeft: '20px' }}>
                <div style={{ marginBottom: '10px', }}>
                    <span style={{ fontSize: 'large', fontWeight: 'bold' }}>{`${record.year || ""} ${record.make || ""} ${record.model || ""} ${record.trim || ""}`}</span>
                </div>
                <div style={{ display: 'inline-flex', width: '100%', ...style.bigFont }}>
                    <div style={{ flex: 5 }}>
                        <div><span>{`${record.vin || ""} `}</span></div>
                        <div><span>{`${record.mileage_km ? record.mileage_km + " KM" : ""}`}</span></div>
                        <div><span style={style.label}>Rate: </span><span>{`${record.rate || ""}`}</span></div>
                        <div><span style={style.label}>Location: </span><span>{`${record.location || ""}`}</span></div>
                    </div>
                    <div style={{ flex: 5 }}>
                        <div><span style={style.label}>MMR in USD: </span><span>{`${record.mmr_usd || ""}`}</span></div>
                        <div><span style={style.label}>Purchased Before: </span><span style={{...style.label, color: record.previous_purchase ? 'red' : undefined}} title={record.previous_purchase || ''}>{record.previous_purchase ? 'See details' : ''}</span></div>
                        <div><span style={style.label}>Start: </span><span>{`${start}`}</span></div>
                        <div><span style={style.label}>End: </span><span>{`${end}`}</span></div>
                    </div>
                    <div style={{ flex: 5 }}>
                        <div><span style={style.label}>USD: </span><span>{`${record.us || ""}`}</span></div>
                        <div><span style={style.label}>CAD:</span><span>{`${record.cad || ""}`}</span></div>
                        <div style={style.bigFont}><span style={style.label}>Current Bid: </span><span>{`${record.current_bid || ""}`}</span></div>
                    </div>
                    <div style={{ flex: 5 }}>
                        <div style={style.bigFont}><span style={style.label}>Winning: </span><span>{`${record.winning || ""}`}</span></div>
                        <div style={style.bigFont}><span style={style.label}>Status: </span><span>{`${record.status || ""}`}</span></div>
                        <div style={style.bigFont}><span style={style.label}>1&2: </span><span>{`${record['1&2'] || ""}`}</span></div>
                        <div style={style.bigFont}><span style={style.label}>Profit: </span><span style={{ color: profit > 0 ? 'green' : 'red', ...style.label }}> {`${profit}`}</span></div>
                    </div>
                    <div style={{ flex: 5 }}>
                        <div style={style.bigFont}><span style={style.label}>Proxy Suggestion: </span><span>{`${record.proxy_suggestion || ""}`}</span></div>
                        <div><ChangeProxyInput {...props} /></div>
                    </div>
                </div>

            </div>
        </div>
    )
};

export default TheBox